import { Lora } from '../interface/Lora.ts';

class GetLorasResponse {
	loras: Lora[];

	constructor(loras: Lora[]) {
		this.loras = loras;
	}

	formatLorasData() {
		if (Array.isArray(this.loras)) {
			return this.loras.map((lora) => ({
				id: lora.id,
				name: lora.display_name,
				description: lora.description,
				image: lora.image_url,
				baseModel: lora.base_model,
				weightage: lora.weightage,
				categories: lora.categories,
				highlighted: lora.highlighted,
				trigger: lora.trigger ?? `<lora:${lora.name}:${lora.weightage}>`,
			}));
		}
		return [];
	}
}

export default GetLorasResponse;
